//#region [IMPORT]

// === THIRD-PARTY ===
import React, {useEffect, useRef, useState} from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Menu,
} from '@mui/material';
import {
  MoreVert,
} from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import {MenuItemLayoutPreset} from './components/MenuItemSaveLayoutPreset/MenuItemSaveLayoutPreset';
import {MenuItemAddPanel} from './components/MenuItemAddPanel/MenuItemAddPanel';
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function SettingsFileView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme    = useTheme();

  const [ anchor, setAnchor ] = useState(null);
  
  const ref_menu = useRef();

  //#endregion
  
  //#region [STYLES]
  
  const _anchor_settings = { anchorName: `--settings_menu` };

  const _fit_content  = { width: 'fit-content', height: 'fit-content'};
  const _z_header     = { zIndex: 1000 };

  const bg = theme.palette.background.primary[theme.palette.mode]+getHexAlpha(80);

  const CONTEXT = {
    PaperProps      : {
      style: {
        margin: '0', padding:'0px', minWidth: '150px',
        background: bg, backdropFilter: 'blur(30px)',
        // background: `radial-gradient(circle, #2e2e2e57 300px, ${bg} 10px)`,    
        border: '1px solid rgba(255, 255, 255, 0.3)', borderRadius: '6px'
      }
    },
    MenuListProps   : {
      disablePadding: true, // Removes top/bottom padding of the list
    },
    open            : anchor !== null,
    onClose         : closeSettings,
    anchorEl        : anchor,
    anchorOrigin    : {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin : {
      vertical: 'top',
      horizontal: 'center',
    }
  }

  //#endregion

  //#region [EFFECT]

  //endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick( event ) {
    //-----------------------------------------------------------------
    event.stopPropagation();
    event.preventDefault();
    
    if( anchor ) setAnchor( null );
    else {
      setAnchor( event.currentTarget );
    }
  }

  //-----------------------------------------------------------------
  function closeSettings() {
    //-----------------------------------------------------------------
    setAnchor( null );
  }

  //-----------------------------------------------------------------
  function handleClickOutside(event) {
    //-----------------------------------------------------------------
    if (ref_menu.current && !ref_menu.current.contains(event.target)) {
      setAnchor( null );
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled ref={ref_menu} styles={[_fit_content, { alignItems: 'center' }, _z_header]}>
        <Styled styles={[ {marginLeft: 'auto'}, {cursor:'pointer'}, _anchor_settings, {height: '30px'},{ alignItems: 'center' } ]} onClick={onClick}>
          <MoreVert fontSize='large' sx={{ margin: 0, color: theme.palette.primary.main }}/>
        </Styled>
        <Menu { ...CONTEXT }>
          <MenuItemLayoutPreset handleClose={closeSettings} />
          <li style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.3)', margin: '4px 12px 4px 12px' }} />
          <MenuItemAddPanel handleClose={closeSettings} />
        </Menu>
      </Styled>
    )
  }

  //#endregion

  return display();
}
